// HERE
interface FoodNode {
    name: string,
    ruta: string,
    status: any,
    seccion: string,
    pos:number,
    children?: FoodNode[]
}
export let datosArbol: FoodNode[] = [
    {
        name: 'WIZARD.MENU_GUIA.MENU.MN28.TITULO',
        ruta:'./inforamcionCT',
        status: 1,
        seccion:'',
        pos:28,
        children : []
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN1.TITULO',
        ruta:'./lista-archivos',
        status: 1,
        seccion:'',
        pos:1,
        children : []
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN2.TITULO',
        ruta:'./aspectos-generales',
        status: 1,
        seccion:'',
        pos:2,
        children : [
            {
                name  : 'WIZARD.MENU_GUIA.MENU.MN3.TITULO',
                ruta : './obj',
                status: 1,
                seccion:'',
                pos:3,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN4.TITULO',
                ruta : './aplicacion',
                status: 1,
                seccion:'',
                pos:4,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN5.TITULO',
                ruta : './referencia',
                status: 1,
                seccion:'',
                pos:5,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN6.TITULO',
                ruta : './definiciones',
                status: 1,
                seccion:'',
                pos:6,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN7.TITULO',
                ruta: './definiciones-tab',
                status: 1,
                seccion:'',
                pos:7,
            }
        ]
    },{
        // name: 'Obligations of the employer',
        name: 'WIZARD.TITLEOBLI',
        ruta: './obligaciones',
        status: 1,
        seccion:'',
        pos:8,
        children : [
            {
                name: 'WIZARD.MENU_GUIA.MENU.MN9.TITULO',
                ruta: './politica',
                status: 2,
                seccion:'5.2 Identificar y analizar los factores de riesgo psicosocial',
                pos:9,
                children : []
            },
            {
                name: 'WIZARD.MENU_GUIA.MENU.MN10.TITULO',
                ruta: 'encuesta-16-50',
                status: 2,
                seccion:'5.3 Identificar y analizar los factores de riesgo psicosocial',
                pos:10,
                children : []
            }/*{
                name: 'WIZARD.MENU_GUIA.MENU.MN11.TITULO',
                ruta: 'encuesta-50-mas',
                status: 2,
                seccion:'5.4 Adoptar las medidas para prevenir y controlar los factores de riesgo psicosocial',
                pos:11,
                children : []
            }*/
            ,{
                name: 'WIZARD.MENU_GUIA.MENU.MN12.TITULO',
                ruta: 'medidas-preventivas&control ',
                status: 2,
                seccion:'5.5 Identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos',
                pos:12,
                children : [
                    /*{
                        name: 'WIZARD.MENU_GUIA.MENU.MN13.TITULO',
                        ruta: 'quejas-denuncias',
                        status: 2,
                        seccion:'5.6 Practicar exámenes médicos y evaluaciones psicológicas',
                        pos:13,
                    },*/{
                        name: 'WIZARD.MENU_GUIA.MENU.MN14.TITULO',
                        ruta: 'plan-acciones',
                        status: 2,
                        seccion:'5.1 a) La prevención de los factores de riesgo psicosocial',
                        pos:14,
                    },{
                        name: 'WIZARD.MENU_GUIA.MENU.MN15.TITULO',
                        ruta: 'kpis',
                        status: 2,
                        seccion:'5.1 b) La prevención de la violencia laboral',
                        pos:15,
                    }
                ]
            }, {
                name: 'WIZARD.MENU_GUIA.MENU.MN16.TITULO',
                ruta: 'encuesta-eventos-traumáticos',
                status: 2,
                seccion:'5.1 c) La promoción de un entorno organizacional favorable',
                pos:16,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN17.TITULO',
                ruta: 'exámenes-médicos',
                status: 2,
                seccion:'5.7 a) La política de prevención de riesgos psicosociales',
                pos:17,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN18.TITULO',
                ruta: 'alteraciones-salud',
                status: 2,
                seccion: '5.7 b) Las medidas adoptadas para combatir las prácticas opuestas',
                pos:18,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN19.TITULO',
                ruta: 'registros',
                status: 2,
                seccion:'5.7 c) Las medidas y acciones de prevención y, en su caso, las acciones ...',
                pos:19,
                children : []
            }

        ]
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN27.TITULO',
        ruta: './obligaciones-colaboradores',
        status: 1,
        seccion:'',
        pos:27,
        children : []

    },{
        name  : 'WIZARD.MENU_GUIA.MENU.MN20.TITULO',
        ruta : './documentos-soporte',
        status: 1,
        seccion:'',
        pos:20,
        children : [
            {
                name: 'WIZARD.MENU_GUIA.MENU.MN21.TITULO',
                ruta: 'guia-I',
                status: 1,
                seccion:'',
                pos:21,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN22.TITULO',
                ruta: './guia-II',
                status: 1,
                seccion:'',
                pos:22,
            },{
                name : 'WIZARD.MENU_GUIA.MENU.MN23.TITULO',
                ruta: 'guia-III',
                status: 1,
                seccion:'',
                pos:23,
            },{
                name: "WIZARD.MENU_GUIA.MENU.MN24.TITULO",
                ruta: './politicas-ejemplo',
                status: 1,
                seccion:'',
                pos:24,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN25.TITULO',
                ruta: 'guia-V',
                status: 1,
                seccion:'',
                pos:25,
            }

        ]
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN26.TITULO',
        ruta: './to-do-task',
        status: 1,
        seccion:'',
        pos:26,
        children : []
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN29.TITULO',
        ruta: './time-line',
        status: 1,
        seccion:'',
        pos:29,
        children : []

    }
];

export let datosArbol_50mas: FoodNode[] = [
    {
        name: 'WIZARD.MENU_GUIA.MENU.MN28.TITULO',
        ruta:'./inforamcionCT',
        status: 1,
        seccion:'',
        pos:28,
        children : []
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN1.TITULO',
        ruta:'./lista-archivos',
        status: 1,
        seccion:'',
        pos:1,
        children : []
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN2.TITULO',
        ruta:'./aspectos-generales',
        status: 1,
        seccion:'',
        pos:2,
        children : [
            {
                name  : 'WIZARD.MENU_GUIA.MENU.MN3.TITULO',
                ruta : './obj',
                status: 1,
                seccion:'',
                pos:3,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN4.TITULO',
                ruta : './aplicacion',
                status: 1,
                seccion:'',
                pos:4,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN5.TITULO',
                ruta : './referencia',
                status: 1,
                seccion:'',
                pos:5,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN6.TITULO',
                ruta : './definiciones',
                status: 1,
                seccion:'',
                pos:6,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN7.TITULO',
                ruta: './definiciones-tab',
                status: 1,
                seccion:'',
                pos:7,
            }
        ]
    },{
        // name: 'Obligations of the employer',
        name: 'WIZARD.TITLEOBLI',
        ruta: './obligaciones',
        status: 1,
        seccion:'',
        pos:8,
        children : [
            {
                name: 'WIZARD.MENU_GUIA.MENU.MN9.TITULO',
                ruta: './politica',
                status: 2,
                seccion:'5.2 Identificar y analizar los factores de riesgo psicosocial',
                pos:9,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN11.TITULO',
                ruta: 'encuesta-50-mas',
                status: 2,
                seccion:'5.4 Adoptar las medidas para prevenir y controlar los factores de riesgo psicosocial',
                pos:11,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN12.TITULO',
                ruta: 'medidas-preventivas&control ',
                status: 2,
                seccion:'5.5 Identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos',
                pos:12,
                children : [
                    {
                        name: 'WIZARD.MENU_GUIA.MENU.MN14.TITULO',
                        ruta: 'plan-acciones',
                        status: 2,
                        seccion:'5.1 a) La prevención de los factores de riesgo psicosocial',
                        pos:14,
                    },{
                        name: 'WIZARD.MENU_GUIA.MENU.MN15.TITULO',
                        ruta: 'kpis',
                        status: 2,
                        seccion:'5.1 b) La prevención de la violencia laboral',
                        pos:15,
                    }
                ]
            }, {
                name: 'WIZARD.MENU_GUIA.MENU.MN16.TITULO',
                ruta: 'encuesta-eventos-traumáticos',
                status: 2,
                seccion:'5.1 c) La promoción de un entorno organizacional favorable',
                pos:16,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN17.TITULO',
                ruta: 'exámenes-médicos',
                status: 2,
                seccion:'5.7 a) La política de prevención de riesgos psicosociales',
                pos:17,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN18.TITULO',
                ruta: 'alteraciones-salud',
                status: 2,
                seccion: '5.7 b) Las medidas adoptadas para combatir las prácticas opuestas',
                pos:18,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN19.TITULO',
                ruta: 'registros',
                status: 2,
                seccion:'5.7 c) Las medidas y acciones de prevención y, en su caso, las acciones ...',
                pos:19,
                children : []
            }

        ]
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN27.TITULO',
        ruta: './obligaciones-colaboradores',
        status: 1,
        seccion:'',
        pos:27,
        children : []

    },{
        name  : 'WIZARD.MENU_GUIA.MENU.MN20.TITULO',
        ruta : './documentos-soporte',
        status: 1,
        seccion:'',
        pos:20,
        children : [
            {
                name: 'WIZARD.MENU_GUIA.MENU.MN21.TITULO',
                ruta: 'guia-I',
                status: 1,
                seccion:'',
                pos:21,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN22.TITULO',
                ruta: './guia-II',
                status: 1,
                seccion:'',
                pos:22,
            },{
                name : 'WIZARD.MENU_GUIA.MENU.MN23.TITULO',
                ruta: 'guia-III',
                status: 1,
                seccion:'',
                pos:23,
            },{
                name: "WIZARD.MENU_GUIA.MENU.MN24.TITULO",
                ruta: './politicas-ejemplo',
                status: 1,
                seccion:'',
                pos:24,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN25.TITULO',
                ruta: 'guia-V',
                status: 1,
                seccion:'',
                pos:25,
            }

        ]
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN26.TITULO',
        ruta: './to-do-task',
        status: 1,
        seccion:'',
        pos:26,
        children : []
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN29.TITULO',
        ruta: './time-line',
        status: 1,
        seccion:'',
        pos:29,
        children : []

    }
];

export let datosArbolBetter: FoodNode[] = [
    {
        name: 'WIZARD.MENU_GUIA.MENU.MN28.TITULO',
        ruta:'./inforamcionCT',
        status: 1,
        seccion:'',
        pos:28,
        children : []
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN1.TITULO',
        ruta:'./lista-archivos',
        status: 1,
        seccion:'',
        pos:1,
        children : []
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN2.TITULO',
        ruta:'./aspectos-generales',
        status: 1,
        seccion:'',
        pos:2,
        children : [
            {
                name  : 'WIZARD.MENU_GUIA.MENU.MN3.TITULO',
                ruta : './obj',
                status: 1,
                seccion:'',
                pos:3,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN4.TITULO',
                ruta : './aplicacion',
                status: 1,
                seccion:'',
                pos:4,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN5.TITULO',
                ruta : './referencia',
                status: 1,
                seccion:'',
                pos:5,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN6.TITULO',
                ruta : './definiciones',
                status: 1,
                seccion:'',
                pos:6,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN7.TITULO',
                ruta: './definiciones-tab',
                status: 1,
                seccion:'',
                pos:7,
            }
        ]
    },{
        // name: 'Obligations of the employer',
        name: 'WIZARD.TITLEOBLI',
        ruta: './obligaciones',
        status: 1,
        seccion:'',
        pos:8,
        children : [
            {
                name: 'WIZARD.MENU_GUIA.MENU.MN9.TITULO',
                ruta: './politica',
                status: 2,
                seccion:'5.2 Identificar y analizar los factores de riesgo psicosocial',
                pos:9,
                children : []
            },
            {
                name: 'WIZARD.MENU_GUIA.MENU.MN10.TITULO',
                ruta: 'encuesta-16-50',
                status: 2,
                seccion:'5.3 Identificar y analizar los factores de riesgo psicosocial',
                pos:10,
                children : []
            }/*{
                name: 'WIZARD.MENU_GUIA.MENU.MN11.TITULO',
                ruta: 'encuesta-50-mas',
                status: 2,
                seccion:'5.4 Adoptar las medidas para prevenir y controlar los factores de riesgo psicosocial',
                pos:11,
                children : []
            }*/
            ,{
                name: 'WIZARD.MENU_GUIA.MENU.MN12.TITULO',
                ruta: 'medidas-preventivas&control ',
                status: 2,
                seccion:'5.5 Identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos',
                pos:12,
                children : [
                    /*{
                        name: 'WIZARD.MENU_GUIA.MENU.MN13.TITULO',
                        ruta: 'quejas-denuncias',
                        status: 2,
                        seccion:'5.6 Practicar exámenes médicos y evaluaciones psicológicas',
                        pos:13,
                    },*/{
                        name: 'WIZARD.MENU_GUIA.MENU.MN14.TITULO',
                        ruta: 'plan-acciones',
                        status: 2,
                        seccion:'5.1 a) La prevención de los factores de riesgo psicosocial',
                        pos:14,
                    },{
                        name: 'WIZARD.MENU_GUIA.MENU.MN15.TITULO',
                        ruta: 'kpis',
                        status: 2,
                        seccion:'5.1 b) La prevención de la violencia laboral',
                        pos:15,
                    }
                ]
            }, {
                name: 'WIZARD.MENU_GUIA.MENU.MN16.TITULO',
                ruta: 'encuesta-eventos-traumáticos',
                status: 2,
                seccion:'5.1 c) La promoción de un entorno organizacional favorable',
                pos:16,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN17.TITULO',
                ruta: 'exámenes-médicos',
                status: 2,
                seccion:'5.7 a) La política de prevención de riesgos psicosociales',
                pos:17,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN18.TITULO',
                ruta: 'alteraciones-salud',
                status: 2,
                seccion: '5.7 b) Las medidas adoptadas para combatir las prácticas opuestas',
                pos:18,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN19.TITULO',
                ruta: 'registros',
                status: 2,
                seccion:'5.7 c) Las medidas y acciones de prevención y, en su caso, las acciones ...',
                pos:19,
                children : []
            }

        ]
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN27.TITULO',
        ruta: './obligaciones-colaboradores',
        status: 1,
        seccion:'',
        pos:27,
        children : []

    },{
        name  : 'WIZARD.MENU_GUIA.MENU.MN20.TITULO',
        ruta : './documentos-soporte',
        status: 1,
        seccion:'',
        pos:20,
        children : [
            {
                name: 'WIZARD.MENU_GUIA.MENU.MN21.TITULO',
                ruta: 'guia-I',
                status: 1,
                seccion:'',
                pos:21,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN22.TITULO',
                ruta: './guia-II',
                status: 1,
                seccion:'',
                pos:22,
            },{
                name : 'WIZARD.MENU_GUIA.MENU.MN23.TITULO',
                ruta: 'guia-III',
                status: 1,
                seccion:'',
                pos:23,
            },{
                name: "WIZARD.MENU_GUIA.MENU.MN24.TITULO",
                ruta: './politicas-ejemplo',
                status: 1,
                seccion:'',
                pos:24,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN25.TITULO',
                ruta: 'guia-V',
                status: 1,
                seccion:'',
                pos:25,
            }

        ]
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN26.TITULO',
        ruta: './to-do-task',
        status: 1,
        seccion:'',
        pos:26,
        children : []
    }
];

export let datosArbol_50masBetter: FoodNode[] = [
    {
        name: 'WIZARD.MENU_GUIA.MENU.MN28.TITULO',
        ruta:'./inforamcionCT',
        status: 1,
        seccion:'',
        pos:28,
        children : []
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN1.TITULO',
        ruta:'./lista-archivos',
        status: 1,
        seccion:'',
        pos:1,
        children : []
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN2.TITULO',
        ruta:'./aspectos-generales',
        status: 1,
        seccion:'',
        pos:2,
        children : [
            {
                name  : 'WIZARD.MENU_GUIA.MENU.MN3.TITULO',
                ruta : './obj',
                status: 1,
                seccion:'',
                pos:3,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN4.TITULO',
                ruta : './aplicacion',
                status: 1,
                seccion:'',
                pos:4,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN5.TITULO',
                ruta : './referencia',
                status: 1,
                seccion:'',
                pos:5,

            },{
                name  : 'WIZARD.MENU_GUIA.MENU.MN6.TITULO',
                ruta : './definiciones',
                status: 1,
                seccion:'',
                pos:6,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN7.TITULO',
                ruta: './definiciones-tab',
                status: 1,
                seccion:'',
                pos:7,
            }
        ]
    },{
        // name: 'Obligations of the employer',
        name: 'WIZARD.TITLEOBLI',
        ruta: './obligaciones',
        status: 1,
        seccion:'',
        pos:8,
        children : [
            {
                name: 'WIZARD.MENU_GUIA.MENU.MN9.TITULO',
                ruta: './politica',
                status: 2,
                seccion:'5.2 Identificar y analizar los factores de riesgo psicosocial',
                pos:9,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN11.TITULO',
                ruta: 'encuesta-50-mas',
                status: 2,
                seccion:'5.4 Adoptar las medidas para prevenir y controlar los factores de riesgo psicosocial',
                pos:11,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN12.TITULO',
                ruta: 'medidas-preventivas&control ',
                status: 2,
                seccion:'5.5 Identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos',
                pos:12,
                children : [
                    {
                        name: 'WIZARD.MENU_GUIA.MENU.MN14.TITULO',
                        ruta: 'plan-acciones',
                        status: 2,
                        seccion:'5.1 a) La prevención de los factores de riesgo psicosocial',
                        pos:14,
                    },{
                        name: 'WIZARD.MENU_GUIA.MENU.MN15.TITULO',
                        ruta: 'kpis',
                        status: 2,
                        seccion:'5.1 b) La prevención de la violencia laboral',
                        pos:15,
                    }
                ]
            }, {
                name: 'WIZARD.MENU_GUIA.MENU.MN16.TITULO',
                ruta: 'encuesta-eventos-traumáticos',
                status: 2,
                seccion:'5.1 c) La promoción de un entorno organizacional favorable',
                pos:16,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN17.TITULO',
                ruta: 'exámenes-médicos',
                status: 2,
                seccion:'5.7 a) La política de prevención de riesgos psicosociales',
                pos:17,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN18.TITULO',
                ruta: 'alteraciones-salud',
                status: 2,
                seccion: '5.7 b) Las medidas adoptadas para combatir las prácticas opuestas',
                pos:18,
                children : []
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN19.TITULO',
                ruta: 'registros',
                status: 2,
                seccion:'5.7 c) Las medidas y acciones de prevención y, en su caso, las acciones ...',
                pos:19,
                children : []
            }

        ]
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN27.TITULO',
        ruta: './obligaciones-colaboradores',
        status: 1,
        seccion:'',
        pos:27,
        children : []

    },{
        name  : 'WIZARD.MENU_GUIA.MENU.MN20.TITULO',
        ruta : './documentos-soporte',
        status: 1,
        seccion:'',
        pos:20,
        children : [
            {
                name: 'WIZARD.MENU_GUIA.MENU.MN21.TITULO',
                ruta: 'guia-I',
                status: 1,
                seccion:'',
                pos:21,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN22.TITULO',
                ruta: './guia-II',
                status: 1,
                seccion:'',
                pos:22,
            },{
                name : 'WIZARD.MENU_GUIA.MENU.MN23.TITULO',
                ruta: 'guia-III',
                status: 1,
                seccion:'',
                pos:23,
            },{
                name: "WIZARD.MENU_GUIA.MENU.MN24.TITULO",
                ruta: './politicas-ejemplo',
                status: 1,
                seccion:'',
                pos:24,
            },{
                name: 'WIZARD.MENU_GUIA.MENU.MN25.TITULO',
                ruta: 'guia-V',
                status: 1,
                seccion:'',
                pos:25,
            }

        ]
    },{
        name: 'WIZARD.MENU_GUIA.MENU.MN26.TITULO',
        ruta: './to-do-task',
        status: 1,
        seccion:'',
        pos:26,
        children : []
    }
];


